import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const updateAdminRoleSlice = getBulkActionSlice(
    'updateAdminRoleResult',
);

export const selectUpdateAdminRoleUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.updateAdminRoleResult.uuid;

export const selectUpdateAdminRoleShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.updateAdminRoleResult.shown;

export const selectUpdateAdminRoleTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.updateAdminRoleResult.backgroundTask;


export const {
    setUuid,
    setShown,
    setBackgroundTask,
    clearResult,
} = updateAdminRoleSlice.actions;
